export default __webpack_public_path__ + "static/LeituraTwo-Black-dc380c4b6ce878aa766558695ffbba73.woff2";